import { createFileRoute } from "@tanstack/react-router";

import { TrainingPlanBuilder } from "@/features/training-plans/modules/training-plan-builder/training-plan-builder";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/library/workouts/$planId")({
  loader: () => ({ crumb: m.library_template_crumb() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { planId } = Route.useParams();
  return <TrainingPlanBuilder planId={planId} />;
}
